module.exports = __webpack_public_path__ + "img/logo.72b30a29.svg";